import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import StorageService from "@/core/services/StorageService";

import requests from "../../requests";

export default {
    listAllowedPrograms({commit}, payload) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setBaseUrl(requests.URL_BASE);
                ApiService.setHeader();
                ApiService.query(requests.ALL_PROGRAMS, {params: payload})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            } else {
                commit("moduleAuth/PURGE_AUTH");
            }
        });
    },
    findProgramDetails({commit}, payload) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setBaseUrl(requests.URL_BASE);
                ApiService.setHeader();
                let refactorURL = requests.FIND_PROGRAM.replace(":id", payload.id);
                ApiService.query(refactorURL, {params: payload})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            } else {
                commit("moduleAuth/PURGE_AUTH");
            }
        });
    },
    findProgram({commit}, payload) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setBaseUrl(requests.URL_BASE);
                ApiService.setHeader();
                let refactorURL = requests.FIND_JSON_FORM.replace(":id", payload.id);
                ApiService.query(refactorURL, {params: payload})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            } else {
                commit("moduleAuth/PURGE_AUTH");
            }
        });
    },
    submitProgram({commit}, payload) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setBaseUrl(requests.URL_BASE);
                ApiService.setHeader();
                let refactorURL = requests.SUBMIT_PROGRAM;//.replace(":id", payload.id);
                ApiService.post(refactorURL, payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            } else {
                commit("moduleAuth/PURGE_AUTH");
            }
        });
    },
    listUserPrograms({commit}, payload) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setBaseUrl(requests.URL_BASE);
                ApiService.setHeader();
                ApiService.query(requests.LIST_USER_PROGRAMS, {params: payload})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            } else {
                commit("moduleAuth/PURGE_AUTH");
            }
        });
    },
    listUserProgramResults({commit}, payload) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setBaseUrl(requests.URL_BASE);
                ApiService.setHeader();
                ApiService.query(requests.LIST_USER_PROGRAM_RESULTS, {params: payload})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            } else {
                commit("moduleAuth/PURGE_AUTH");
            }
        });
    },
    getSubmittedProgram({commit}, payload) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setBaseUrl(requests.URL_BASE);
                ApiService.setHeader();
                let refactorURL = requests.GET_SUBMITTED_FORM.replace(":id", payload.id);
                ApiService.query(refactorURL, {params: payload})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            } else {
                commit("moduleAuth/PURGE_AUTH");
            }
        });
    },
    setFormJson({commit}, payload) {
        commit("SET_FORM_JSON", payload);
    },
};
